export class CapabilityToken {
  static ICapabilityRepository = Symbol("ICapabilityRepository");
  static CapabilityUseCase = Symbol("CapabilityUseCase");
  static CapabilityViewModel = Symbol("CapabilityViewModel");
}
